import React, { useState } from 'react'
import arrowBelow from '../../assets/img/icon/arrow-below.png';
import arrowRight from '../../assets/img/icon/arrow-right.svg';
import { FiHome } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import { SlHome } from "react-icons/sl";

const SubHeading = ({ heading }) => {
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const handleMobileNavToggle = () => {
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    const handleMobileNavItemClick = (item) => {
        setIsMobileNavOpen(false);
        // Handle navigation based on item
        navigate(`/${item}`);
    };

    return (
        <>
            {/* Page Header */}
            <div className={`page-header ${isMobileNavOpen ? 'mobile-menu-open' : ''}`}>
                <div className="page-title-section">
                    <div className="title-line"></div>
                    <div className="title-content">
                        <h1 className="page-title">{heading}</h1>
                    </div>
                </div>
                <div className="breadcrumb-navigation">
                    <span className="breadcrumb-item">
                        <SlHome size={16} />
                    </span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item">고객센터</span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item active">{heading}</span>
                </div>

                <div className="mobile-navigation-section">
                    <img src={arrowBelow} alt="mobile-nav-icon" onClick={handleMobileNavToggle} className={isMobileNavOpen ? 'active' : ''} />
                </div>

            </div>

            {/* Mobile Navigation */}
            {isMobileNavOpen && (
                <div className="mobile-navigation">

                    <div className="mobile-nav-items">
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('announcements') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('announcements')}
                        >
                            <span>공지사항</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('memorial-news') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('memorial-news')}
                        >
                            <span>추모원 소식</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('faq') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('faq')}
                        >
                            <span>자주하는 질문</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('contact-us') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('contact-us')}
                        >
                            <span>문의하기</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                    </div>

                </div>
            )}
        </>
    )
};

export default SubHeading;




